// 운동종목 코드 → 한글 라벨. MemberFilter.jsx 의 SPORT_TYPE_LABELS 와 동일한 표기를 따른다.
const SPORT_TYPE_LABELS = {
  FITNESS: '피트니스 / P.T',
  PILATES: '필라테스',
  BARRE_PILATES: '바레 필라테스',
  GOLF: '골프',
  YOGA: '요가',
  CROSSFIT: '크로스핏',
  BALL_GAMES: '구기 / 라켓',
  BOXING: '복싱 / 격투',
  DANCE: '댄스',
  SWIMMING: '수영 / 수상',
  CYCLE: '사이클',
  EDUCATION: '교육',
  TANNING: '태닝',
  STRETCHING: '스트레칭',
};

/**
 * 상품 카드에 표시할 운동종목 문자열을 만든다.
 * 백엔드는 다종목 상품을 위해 sportTypes 배열을 내려주고, 단일 종목 상품은 1건짜리 배열이다.
 * 종목이 없으면 null 을 반환해 호출부에서 행 자체를 렌더링하지 않게 한다.
 */
export const formatSportTypes = sportTypes => {
  if (!Array.isArray(sportTypes) || sportTypes.length === 0) {
    return null;
  }

  return sportTypes.map(type => SPORT_TYPE_LABELS[type] || type).join(', ');
};
